import { Expose, Type } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";
import { TrackingGiftSummary } from "src/shared/models/tracking-gift-summary.model";

export class VehicleTracking extends BaseModel {
    @Expose() billingDate = "";
    @Expose() endCutoffDate = "";
    @Expose() fixedAmount = -1;
    @Expose() installationDate: Nullable<string> = null;
    @Expose() km = 0.0;
    @Expose() kmPrice = 0.0;
    @Expose() startCutoffDate = "";
    @Expose() totalAmount = 0.0;
    @Expose()
    @Type(() => TrackingGiftSummary)
    giftSummary?: TrackingGiftSummary;
}
